import React from 'react';
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import purple from '@material-ui/core/colors/purple';
import { withStyles } from '@material-ui/core/styles';
import ThetaBind from './ThetaBind';
import classNames from 'classnames';
import { I18n } from 'aws-amplify';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import "./smartdevice.css";
import { Auth } from 'aws-amplify';
import Divider from '@material-ui/core/Divider';
import CloseIcon from '@material-ui/icons/Close';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import DialogContentText from '@material-ui/core/DialogContentText';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';

var width = window.outerWidth || document.body.clientWidth;

const styles = theme => ({
  colorSwitchBase: {
    color: purple[300],
    '&$colorChecked': {
      color: purple[500],
      '& + $colorBar': {
        backgroundColor: purple[500],
      },
    },
  },
  colorBar: {},
  colorChecked: {},
  iOSSwitchBase: {
    '&$iOSChecked': {
      color: theme.palette.common.white,
      '& + $iOSBar': {
        backgroundColor: '#52d869',
      },
    },
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.sharp,
    }),
  },
  iOSChecked: {
    transform: 'translateX(15px)',
    '& + $iOSBar': {
      opacity: 1,
      border: 'none',
    },
  },
  iOSBar: {
    borderRadius: 13,
    width: 42,
    height: 26,
    marginTop: -13,
    marginLeft: -21,
    border: 'solid 1px',
    borderColor: theme.palette.grey[400],
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  iOSIcon: {
    width: 24,
    height: 24,
  },
  iOSIconChecked: {
    boxShadow: theme.shadows[1],
  },
  root: {
    backgroundColor: theme.palette.background.paper,
    borderTop: '1px solid #ccc',
    borderBottom: '1px solid #ccc',
  },
});

const DialogTitle = withStyles(theme => ({
  root: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    margin: 0,
    padding: theme.spacing.unit * 2,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing.unit,
    top: theme.spacing.unit,
    color: theme.palette.grey[500],
  },
}))(props => {
  const { children, classes, onClose } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} style={{ background:'#e0e0e0' }}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="Close" className={classes.closeButton} onClick={onClose} style={{ color:'#ffffff',background:'#64dd17',padding:'0px' }}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing.unit * 2,
  },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    // borderTop: `1px solid ${theme.palette.divider}`,
    margin: 0,
    padding: theme.spacing.unit,
  },
}))(MuiDialogActions);

class ThetaBindList extends React.Component {

  state = {
    bitem: undefined,
    open: false,
    videoJsOptions: undefined,
    confirm: false,
  };

  componentDidMount() {
    this.props.onMount(this.props.categoryId);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.categoryId !== nextProps.categoryId) {
      this.props.onUpdate(nextProps.categoryId);
    }
    if (nextProps.ranking !== undefined &&
      nextProps.ranking !== this.props.ranking) {
      this.setState({
        ranking: nextProps.ranking
      });
    }
    
    if (nextProps.statusCode !== this.props.statusCode){
      this.setState({
        statusCode: nextProps.statusCode
      });
    }
    
    if (nextProps.checkedB !== this.props.checkedB){
      this.setState({
        checkedB: nextProps.checkedB
      });
    }
  }

  updateState(state) {
    this.setState(state);
  }

  linkTo(link) {
    this.props.history.push(link);
  }

  handleToggle = (item) => {

    this.setState({
      bitem: item,
    });
  };

  handleLogout = () => {
    Auth.signOut()
      .then(data => console.log(data))
      .catch(err => console.log(err));
    window.location.reload();
  };
  
  handleClose = (item) => {
      this.setState({ confirm: false });
  };
  
  handleClose2 = (item) => {
      this.setState({ confirm: false });
      Auth.signOut()
        .then(data => console.log(data))
        .catch(err => console.log(err));
      window.location.reload();
  };

  handleUnsubscribeAccount= statusCode => {
    this.props.onUnsubscribeAccount();
    this.handleClose();
    this.updateStatusCode();
  };
  
  updateStatusCode(){
    this.setState({ statusCode: this.state.statusCode });
  }
  
  handleClickConfirm = () => {
      this.setState({ confirm: true });
  };

  render() {
    const { classes, getOptions, videoJsOptions, error ,uploadCheck} = this.props;
    const { ranking, bitem, open , statusCode,checkedB } = this.state;
    return (
      <div className="App">
        {(() => {
            if (error) {
                return <p className="error">{I18n.get("error")}</p>;
            } else if (typeof bitem === 'undefined' && typeof ranking === 'undefined' && typeof getOptions === 'undefined' && open === false ) {
                return <p className="loading">{I18n.get("loading")}</p>
            } else if (bitem !== undefined) {
                return <ThetaBind
                componentDidMount={this.componentDidMount.bind(this)}
                onShootingMount={this.props.onShootingMount.bind(this)}
                onPostDate={this.props.onPostDate.bind(this)}
                onShootingPostDate={this.props.onShootingPostDate.bind(this)}
                item={bitem}
                ranking={ranking}
                open={open}
                getOptions={getOptions}
                videoJsOptions={videoJsOptions}
                updateState={this.updateState.bind(this)}
                linkTo={this.linkTo.bind(this)}
                statusCode={statusCode}
                uploadCheck={uploadCheck}
                checkedB={checkedB} />;
            } else {
            if (width > 320){
              return (
                <ol>
                <ul className="header_short header_medium">
                <li className="back_button"></li>
                <li className="title_short"><nobr><p className="title_medium">{I18n.get("SmartDevice")}</p></nobr></li>
                <li className="logout_button"><Button style={{fontSize: 'small' }} size="medium" onClick={this.handleLogout}>{I18n.get("Sign Out")}</Button></li>
              　</ul>
                <ol className="subheader">{I18n.get("connected theta")}</ol>
                <div className={classes.root}>
                <List 
                  disablePadding={true}
                  style={{border: 'none'}}>
                {ranking === undefined || ranking.lenth === 0?
                    <div className={classNames('item-link','item-content')}>
                      <ListItem>
                        <ListItemText
                          primary={I18n.get("not connected")}
                        />
                      </ListItem>
                      <Divider />
                     </div>
                :
                <div className={classNames('item-link','item-content')}>
                {ranking.map((item,i) => (
                      <ListItem
                        key={item.serialnumber}
                        role={undefined}
                        dense
                        button
                        divider={true}
                        onClick={() => {this.handleToggle(item)}}
                      >
                        <ListItemText
                          primary={<Typography type="body2" style={{ fontSize:'small' }}  >{`${item.displayname}`}</Typography>}
                        />
                        <ListItemIcon>
                            <KeyboardArrowRight />
                        </ListItemIcon>
                        </ListItem>
                ))}
                </div>
                }
                </List>
                </div>
                <List>
                      <ListItem
                        className={classes.root}
                        role={undefined}
                        dense
                        button
                        disabled={(ranking.length > 0 )?true:false}
                        onClick={() => {this.props.history.push('/detect')}}
                        >
                        <ListItemText
                        disableTypography
                        primary={<Typography type="body2" style={{ color: '#0088bd',fontSize:'small' }}  ><p className='register_theta'>{I18n.get("register theta")}</p></Typography>}
                        />
                        </ListItem>
                </List>
                <div>
                <p className="upper_introduction">{I18n.get("upper introduction")}</p>
                </div>
                <Divider />
                <div className="unsubscribe_button"><Button style={{fontSize: 'small' }} size="medium" onClick={this.handleClickConfirm}>{I18n.get("unsubscribe account")}</Button></div>
                <Dialog
                    open={this.state.confirm && statusCode!==200}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    onUnsubscribeAccount={this.props.onUnsubscribeAccount}
                  >
                    <DialogTitle id="alert-dialog-title" onClose={this.handleClose}>{I18n.get("unsubscribe account title")}</DialogTitle>
                    <DialogContent style={{ background:'#eeeeee' }}>
                      <DialogContentText id="alert-dialog-description">
                        {I18n.get("unsubscribe account text")}
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions style={{ background:'#eeeeee' }}>
                      <Button onClick={this.handleUnsubscribeAccount} style={{ color:'#ffffff',background:'#64dd17',fontWeight:'1000' }}>
                        {I18n.get("ok")}
                      </Button>
                      <Button onClick={this.handleClose} style={{ color:'#ffffff',background:'#64dd17',fontWeight:'1000' }} autoFocus>
                        {I18n.get("back")}
                      </Button>
                    </DialogActions>
                  </Dialog>
                  <Dialog
                    open={statusCode === 200}
                    onClose={this.handleClose2}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle id="alert-dialog-title" onClose={this.handleClose}>{I18n.get("unsubscribe account finish title")}</DialogTitle>
                    <DialogContent style={{ background:'#eeeeee' }}>
                      <DialogContentText id="alert-dialog-description" className="dialog_text">
                        {I18n.get("unsubscribe account finish text")}
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions style={{ background:'#eeeeee' }}>
                      <Button onClick={this.handleClose2} style={{ color:'#ffffff',background:'#64dd17',fontWeight:'1000' }} autoFocus>
                         {I18n.get("ok")}
                      </Button>
                    </DialogActions>
                  </Dialog>
                </ol>
              );
            } else {
               return (
                <ol>
                <ul className="header_short header_medium">
                <li className="back_button_bindlist_iphone_se"></li>
                <li className="title_short_bindlist_iphone_se"><nobr><p className="title_medium">{I18n.get("SmartDevice")}</p></nobr></li>
                <li className="logout_button_bindlist_iphone_se"><Button onClick={this.handleLogout}>{I18n.get("Sign Out")}</Button></li>
              　</ul>
                <ol className="subheader">{I18n.get("connected theta")}</ol>
                <div className={classes.root}>
                <List 
                  disablePadding={true}
                  style={{border: 'none'}}>
                {ranking === undefined || ranking.lenth === 0?
                    <div className={classNames('item-link','item-content')}>
                      <ListItem>
                        <ListItemText
                          primary={I18n.get("not connected")}
                        />
                      </ListItem>
                     </div>
                :
                <div className={classNames('item-link','item-content')}>
                {ranking.map((item,i) => (
                      <ListItem
                        key={item.serialnumber}
                        role={undefined}
                        dense
                        button
                        divider={true}
                        onClick={() => {this.handleToggle(item)}}
                      >
                        <ListItemText
                          primary={<Typography type="body2" style={{ fontSize:'small' }}  >{`${item.displayname}`}</Typography>}
                        />
                        <ListItemIcon>
                            <KeyboardArrowRight />
                        </ListItemIcon>
                        </ListItem>
                ))}
                </div>
                }
                </List>
                </div>
                <List>
                      <ListItem
                        className={classes.root}
                        role={undefined}
                        dense
                        button
                        disabled={(ranking.length > 0 )?true:false}
                        onClick={() => {this.props.history.push('/detect')}}
                        >
                        <ListItemText
                        disableTypography
                        primary={<Typography type="body2" style={{ color: '#0088bd',fontSize:'small' }}  ><p className='register_theta'>{I18n.get("register theta")}</p></Typography>}
                        />
                        </ListItem>
                </List>
                <div>
                <p className="upper_introduction">{I18n.get("upper introduction")}</p>
                </div>
                <Divider />
                <div className="unsubscribe_button"><Button style={{fontSize: 'small' }} size="medium" onClick={this.handleClickConfirm}>{I18n.get("unsubscribe account")}</Button></div>
                <Dialog
                    open={this.state.confirm && statusCode!==200}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    onUnsubscribeAccount={this.props.onUnsubscribeAccount}
                  >
                    <DialogTitle id="alert-dialog-title" onClose={this.handleClose}>{I18n.get("unsubscribe account title")}</DialogTitle>
                    <DialogContent style={{ background:'#eeeeee' }}>
                      <DialogContentText id="alert-dialog-description">
                        {I18n.get("unsubscribe account text")}
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions style={{ background:'#eeeeee' }}>
                      <Button onClick={this.handleUnsubscribeAccount} style={{ color:'#ffffff',background:'#64dd17',fontWeight:'1000' }}>
                        {I18n.get("ok")}
                      </Button>
                      <Button onClick={this.handleClose} style={{ color:'#ffffff',background:'#64dd17',fontWeight:'1000' }} autoFocus>
                        {I18n.get("back")}
                      </Button>
                    </DialogActions>
                  </Dialog>
                  <Dialog
                    open={statusCode === 200}
                    onClose={this.handleClose2}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle id="alert-dialog-title" onClose={this.handleClose}>{I18n.get("unsubscribe account finish title")}</DialogTitle>
                    <DialogContent style={{ background:'#eeeeee' }}>
                      <DialogContentText id="alert-dialog-description" className="dialog_text">
                        {I18n.get("unsubscribe account finish text")}
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions style={{ background:'#eeeeee' }}>
                      <Button onClick={this.handleClose2} style={{ color:'#ffffff',background:'#64dd17',fontWeight:'1000' }} autoFocus>
                         {I18n.get("ok")}
                      </Button>
                    </DialogActions>
                  </Dialog>
                </ol>
              );
            }
            }
        })()}
        </div>
    );
  }
}

ThetaBindList.propTypes = {
  category: PropTypes.string,
  categoryId: PropTypes.string,
  onMount: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  onUnsubscribeAccount: PropTypes.func.isRequired,

  ranking: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      imageUrl: PropTypes.string.isRequired
    })
  ),
  item: PropTypes.shape({
    code: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    imageUrl: PropTypes.string.isRequired
  }),

  error: PropTypes.bool.isRequired
};

ThetaBindList.defaultProps = {
  categoryId: '1'
};

export default withStyles(styles)(ThetaBindList);



// WEBPACK FOOTER //
// ./src/components/ThetaBindList.js